<template>
  <div class="report-bd tb" v-if="funcView.robotLog_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" @click="onUpdate" v-repeat="5000" :disabled="!Object.keys(selectedRow).length">
            {{ $t('report_robotLog.geng_xin_ji_lu') }}
          </el-button>
        </el-form-item>
        <el-form-item
          style="float: right; margin-right: 0 "
          v-if="funcView.robotLog_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="onExport"
            :disabled="exporting"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right;">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('report_robotLog.ji_shen_hao')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="getTableList"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
      <!-- 产品型号 -->
        <el-form-item :label="$t('report_robotLog.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="i18n.com_please_select"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 项目 -->
        <el-form-item :label="$t('report_robotLog.xiang_mu')">
          <el-input v-model="formSearch.locationName" clearable ></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.qu_yu')">
          <el-input v-model="formSearch.siteName" style="width: 100%" clearable >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.qu_yuID')">
          <el-input v-model="formSearch.siteId" style="width: 100%" clearable >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.ding_wei_ma')">
          <el-input v-model="formSearch.hlcCode" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.di_tu_ming_cheng')">
          <el-input v-model="formSearch.mapName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.zong_bu')">
          <!-- <el-input v-model="formSearch.hqId" style="width: 100%" clearable >
          </el-input> -->
          <custom-select
            v-model="formSearch.hqId"
            url="organRelationOrganList"
            :listener="`${formSearch.hqName}`"
            width="100%"
            filterable
            remote
            :props="{label:'orgName',value:'orgId'}"
            :params="{orgType:'HQ',queryNum:50,search:formSearch.hqName}"
            @change="onHqChange"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.zu_lin_fang')">
          <!-- <el-input v-model="formSearch.customerId" style="width: 100%" clearable > </el-input>-->
          <custom-select
            v-model="formSearch.customerId"
            url="organRelationOrganList"
            :listener="`${formSearch.customerName}`"
            width="100%"
            filterable
            remote
            :props="{label:'orgName',value:'orgId'}"
            :params="{orgType:'CS',queryNum:50,search:formSearch.customerName}"
            @change="onCustomerChange"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.dai_li_gong_si')">
          <!-- <el-input v-model="formSearch.agentCoId" style="width: 100%" clearable ></el-input> -->
          <!-- <custom-select v-model="formSearch.agentCoId"  :params="{search:50,}" :props="{ label: 'label', value: 'value' }" placeholder="" url="organRelationOrganList"></custom-select> -->
          <custom-select
            v-model="formSearch.agentCoId"
            url="organRelationOrganList"
            :listener="`${formSearch.agentCoName}`"
            width="100%"
            filterable
            remote
            :props="{label:'orgName',value:'orgId'}"
            :params="{orgType:'JV',queryNum:50,search:formSearch.agentCoName}"
            @change="onAgentCoChange"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.shou_hou_gong_si')">
          <!-- <el-input v-model="formSearch.agentCoId" style="width: 100%" clearable ></el-input> -->
          <!-- <custom-select v-model="formSearch.agentCoId"  :params="{search:50,}" :props="{ label: 'label', value: 'value' }" placeholder="" url="organRelationOrganList"></custom-select> -->
          <custom-select
            v-model="formSearch.afterServiceId"
            url="organRelationOrganList"
            :listener="`${formSearch.afterServiceName}`"
            width="100%"
            filterable
            remote
            :props="{label:'orgName',value:'orgId'}"
            :params="{orgType:'JV_SC',queryNum:50,search:formSearch.afterServiceName}"
            @change="onAgentCoChange"
          ></custom-select>
        </el-form-item>
        <!-- 时间 -->
        <el-form-item :label="$t('report_robotLog.jie_shu_shi_jian')" class="select-date">
          <!-- 天 -->
          <custom-date-picker
            v-model="formSearch.dateTimes"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :clearable="false"
            :picker-options="pickerOptionsIntervalThreeMonth"
          ></custom-date-picker>
        </el-form-item>
        <!-- 次数 -->
        <el-form-item :label="$t('report_robotLog.zan_ting_ci_shu')">
          <input-range v-model="pauseCount" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.fu_zhu_ci_shu')">
          <input-range v-model="assistCount" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.peng_zhuang_ci_shu')">
          <input-range v-model="formSearch.bumpeCount" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.xuan_ya_ci_shu')">
          <input-range v-model="formSearch.cliffCount" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('report_robotLog.duo_xuan_ya_ci_shu')">
          <input-range v-model="multCliffCount" type="number" style="width: 100%" />
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <!-- {{ tableList }} -->
      <custom-table
        v-if="isInch"
        ref="customTb1"
        tableCode="robot_workLog_list_ft"
        type="radio"
        v-model="selectedRow"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['runRoute','bodyNum','cleanedArea', 'runLength','assistCount','bumperCount','cliffCount','multCliffCount','pauseCount','eventCount']"
        @sort="sortChange"
        @filter="filterChange"
      >
        <!--
          manualCleanArea
          autonomousCleanArea
        -->
        <template
          slot="bodyNum"
          slot-scope="scope"
        >
          <div
            v-if="scope.row.bodyNum"
            class="cell-link"
            @click="jump('/devicedetail', { bodyNum: scope.row.bodyNum, parentPath: $route.path })"
          >{{ scope.row.bodyNum }}</div>
        </template>
        <template v-slot:cleanedArea="scope">
          <span>{{$formatLenLocal(scope.row.cleanedArea)}}</span>
        </template>
        <template v-slot:runLength="scope">
          <span>{{$formatLenLocal(scope.row.runLength,true)}}</span>
        </template>
        <template v-slot:assistCount="scope">
          <span
            v-if="scope.row.assistCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'2')"
          >
            {{ scope.row.assistCount }}
          </span>
          <span v-else>{{scope.row.assistCount}}</span>
        </template>
        <template v-slot:bumperCount="scope">
          <span
            v-if="scope.row.bumperCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'3' )"
          >
            {{ scope.row.bumperCount }}
          </span>
          <span v-else>{{scope.row.bumperCount}}</span>
        </template>
        <template v-slot:cliffCount="scope">
          <span
            v-if="scope.row.cliffCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'4' )"
          >
            {{ scope.row.cliffCount }}
          </span>
          <span v-else>{{scope.row.cliffCount}}</span>
        </template>
        <template v-slot:multCliffCount="scope">
          <span
            v-if="scope.row.multCliffCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'5' )"
          >
            {{ scope.row.multCliffCount }}
          </span>
          <span v-else>{{scope.row.multCliffCount}}</span>
        </template>
        <template v-slot:pauseCount="scope">
          <span
            v-if="scope.row.pauseCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'1' )"
          >
            {{ scope.row.pauseCount }}
          </span>
          <span v-else>{{scope.row.pauseCount}}</span>
        </template>
        <template v-slot:eventCount="scope">
          <span
            v-if="scope.row.eventCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'0' )"
          >
            {{ scope.row.eventCount }}
          </span>
          <span v-else>{{scope.row.eventCount}}</span>
        </template>
        <template v-slot:runRoute="scope">
          <span
            v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
            style="cursor: pointer; color: #0d9ae0"
            @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
          >
            {{ $t('Common.com_detail') }}
          </span>
        </template>
      </custom-table>
      <custom-table
        v-if="!isInch"
        ref="customTb1"
        tableCode="robot_workLog_list"
        type="radio"
        v-model="selectedRow"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :slots="['runRoute','bodyNum','assistCount','bumperCount','cliffCount','multCliffCount','pauseCount','eventCount']"
      >
        <template
          slot="bodyNum"
          slot-scope="scope"
        >
          <div
            v-if="scope.row.bodyNum"
            class="cell-link"
            @click="jump('/devicedetail', { bodyNum: scope.row.bodyNum, parentPath: $route.path })"
          >{{ scope.row.bodyNum }}</div>
        </template>
        <template v-slot:assistCount="scope">
          <span
            v-if="scope.row.assistCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'2' )"
          >
            {{ scope.row.assistCount }}
          </span>
          <span v-else>{{scope.row.assistCount}}</span>
        </template>
        <template v-slot:bumperCount="scope">
          <span
            v-if="scope.row.bumperCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'3' )"
          >
            {{ scope.row.bumperCount }}
          </span>
          <span v-else>{{scope.row.bumperCount}}</span>
        </template>
        <template v-slot:cliffCount="scope">
          <span
            v-if="scope.row.cliffCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'4' )"
          >
            {{ scope.row.cliffCount }}
          </span>
          <span v-else>{{scope.row.cliffCount}}</span>
        </template>
        <template v-slot:multCliffCount="scope">
          <span
            v-if="scope.row.multCliffCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'5' )"
          >
            {{ scope.row.multCliffCount }}
          </span>
          <span v-else>{{scope.row.multCliffCount}}</span>
        </template>
        <template v-slot:pauseCount="scope">
          <span
            v-if="scope.row.pauseCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'1' )"
          >
            {{ scope.row.pauseCount }}
          </span>
          <span v-else>{{scope.row.pauseCount}}</span>
        </template>
        <template v-slot:eventCount="scope">
          <span
            v-if="scope.row.eventCount>0"
            style="cursor: pointer; color: #0d9ae0"
            @click="onEventDetails(scope.row,'0' )"
          >
            {{ scope.row.eventCount }}
          </span>
          <span v-else>{{scope.row.eventCount}}</span>
        </template>
        <template v-slot:runRoute="scope">
            <span
              v-if="!!scope.row.routeId && (`${scope.row.workClass}` === '5' || `${scope.row.workClass}` === '4')"
              style="cursor: pointer; color: #0d9ae0"
              @click="mapIdDetails(scope.row.routeId, scope.row.workClass)"
            >
              {{ $t('Common.com_detail') }}
            </span>
          </template>

    </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 查看地图图片 -->
    <!-- <el-dialog v-drag-dialog :title="$t('com_picture_preview')" :append-to-body="true" :visible.sync="dialogVisibleImage">
        <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog> -->
    <el-image-viewer v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
    <!-- 事件详情 -->
    <robotLog-event-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
    ></robotLog-event-dialog>

  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import inputRange from '@/components/inputRange';
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import robotLogEventDialog from './children/robotLog_event_dialog';
// import引入
export default {
  name: 'robotLog',
  mixins: [resetFormSearchMixins, tableFilterValueMixins],
  components: {
    robotLogEventDialog, inputRange
  },

  data() {
    return {
      provide: true,
      formSearch: {
        reportType: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        productCode: '',
        locationName: '',
        siteName: '',
        siteId: '',
        hlcCode: '',
        hqId: '',
        mapName: '',
        hqName: '',
        customerId: '',
        customerName: '',
        agentCoId: '',
        agentCoName: '',
        afterServiceId: '',
        afterServiceName: '',
        startTime: '',
        endTime: '',
        // 日
        dateTimes: [this.$momentWorld(moment(this.$getLocalTime()).subtract(30, 'days').startOf('day').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))],
        cliffCount: [],

        bumpeCount: [],
      },
      pauseCount: [],
      assistCount: [],

      selectedRow: {},
      tagId: '',
      tags: [],
      multCliffCount: [],
      selectDate: '',
      // 日期选择范围在一个月内
      pickerOptions: {
        firstDayOfWeek: 1,
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        // eslint-disable-next-line consistent-return
        disabledDate: (time) => {
          if (this.selectDate) {
            const limitRange = 186 * 24 * 3600 * 1000; // 31天范围内可选
            const maxTime = this.selectDate + limitRange;
            const minTime = this.selectDate - limitRange;
            return (
              time.getTime() > maxTime
              || time.getTime() < minTime
              || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000
            );
          } else {
            return time.getTime() > Date.now() + 0 * 24 * 3600 * 1000;
          }
        },
      },

      tableList: [],
      totalRows: 0,
      dialogVisibleImage: false,
      dialogImageUrl: '',

      link: null,
      exporting: false,

      // 事件
      dialogVisible: false,
      dialogModel: {},
    };
  },

  mounted: function () {
    this.formSearch.startTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[0] : '';
    this.formSearch.endTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[1] : '';
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });


    this.getTableList();
  },
  methods: {
    // 获取列表
    getTableList() {
      // 时间
      this.formSearch.startTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[0] : '';
      this.formSearch.endTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[1] : '';
      // 次数pauseStartCount
      this.formSearch.pauseStartCount = this.pauseCount ? this.pauseCount[0] : '';
      this.formSearch.pauseEndCount = this.pauseCount ? this.pauseCount[1] : '';
      this.formSearch.assistStartCount = this.assistCount ? this.assistCount[0] : '';
      this.formSearch.assistEndCount = this.assistCount ? this.assistCount[1] : '';
      this.formSearch.bumpeStartCount = this.formSearch.bumpeCount ? this.formSearch.bumpeCount[0] : '';
      this.formSearch.bumpeEndCount = this.formSearch.bumpeCount ? this.formSearch.bumpeCount[1] : '';
      this.formSearch.cliffStartCount = this.formSearch.cliffCount ? this.formSearch.cliffCount[0] : '';
      this.formSearch.cliffEndCount = this.formSearch.cliffCount ? this.formSearch.cliffCount[1] : '';
      this.formSearch.multCliffStartCount = this.multCliffCount ? this.multCliffCount[0] : '';
      this.formSearch.multCliffCountEndCount = this.multCliffCount ? this.multCliffCount[1] : '';


      this.$getDebounceJSON(apis.workRunRobotPage, this.formSearch)
        .then((res) => {
          const data = res.data.list;
          this.nullValueToCrossbar(data, ['assistCount', 'bumperCount', 'cliffCount', 'multCliffCount', 'eventCount', 'pauseCount', 'startEventVal']);
          this.tableList = data;
          this.totalRows = res.data.total;
        })
        .catch(() => {
          this.tableList = [];
        });

    },
    onUpdate() {
      const id = this.selectedRow.id;
      this.$getJSON(`${apis.workRunRobotUpdateEventParam}/${id}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.getTableList();
      });
    },
    onCustomerChange: function (item) {
      this.formSearch.customerName = item.orgName;
    },
    onHqChange: function (item) {
      this.formSearch.hqName = item.orgName;
    },
    onAgentCoChange: function (item) {
      this.formSearch.agentCoName = item.orgName;
    },

    mapIdDetails(routeId, workClass) {
      // w是自主
      // t是教学
      let type = '';
      if (`${workClass}` === '5') {
        type = 'w';
      } else if (`${workClass}` === '4') {
        type = 't';
      }
      if (!routeId || !type) {
        return;
      }
      this.$getJSON(`${apis.OssAttach}/${routeId}/${type}`).then((res) => {
        const list = res.data || [];
        const url = this.getAttachUrl(list[0]);
        this.dialogImageUrl = url;
        this.dialogVisibleImage = true;
      });
    },

    onEventDetails(row, val) {
      this.dialogVisible = true;
      this.dialogModel.data = {
        workRunId: row.id,
        type: val,
        bodyNum: row.bodyNum,
        startDate: row.startTime,
        endDate: row.endTime
      };
      this.dialogModel.title = this.$t('report_robotLog.shi_jian_xiang_qingo', [row.bodyNum]);
      this.dialogModel.timeMsg = `${this.$momentLocal(row.startTime)} ~ ${this.$momentLocal(row.endTime)}`;
    },
    onExport: function () {
      this.exporting = true;
      this.exportTable('workRunRobotExport', this.formSearch).then(() => {
        this.exporting = false;
      }).catch(() => {
        this.exporting = false;
      });
    },
    // 过滤
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.pauseCount = [];
      this.assistCount = [];
      this.formSearch.bumpeCount = [];
      this.formSearch.cliffCount = [];
      this.multCliffCount = [];
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
// @import '@/style/colors.scss';
.report-bd {


    .week-picker,
    .season-picker,
    .year-picker {
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 47% !important;
        &:last-of-type {
          float: right;
        }
      }
      // .icon-calendar:before{
      //   content: "\E78E";
      // }
      // i {
      //   flex: 1;
      //   text-align: center;
      // }
    }
    .select-date{
      .el-input .el-input__inner {
          cursor: pointer;
          text-align: center;
        }
    }


    .season-picker {
      display: flex;
      justify-content: space-between;
      .quarter-picker {
        width: 47% !important;
        .el-input {
          width: 100% !important;
        }
        &:last-of-type {
          float: right;
        }
      }
      // i {
      //   flex: 1;
      //   text-align: center;
      // }
    }

  // 时间框
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    .el-input__inner {
      padding: 0 12px 0 32px;
      font-size: 14px;
    }
    .el-input__prefix {
      left: 10px;
    }
    .icon-calendar {
      font-size: 14px;
      color: rgba(13, 154, 224, 1);
    }
  }
}
</style>
